module.exports = __webpack_public_path__ + "static/media/46.3173593f.png";